<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div no-body class="mb-1" style="width: 100%; position: relative;" ref="selectKits" v-b-tooltip.hover.topleft.v-light :title="tratamiento.nombreKit">
      <div class="scrollable-container-tratamientos barras d-flex " style="margin-top: 10px;">
        <span class="text-left"><b-badge pill variant="success">KIT</b-badge></span>
        <b-form-input class="input-filter" v-model="tratamiento.nombreKit" @click="toggleCollapse" placeholder="Selecciona un kit" type="text" @input="buscarKit()" @keydown.enter.prevent="buscarKit()">
        </b-form-input>
        <b-icon icon="chevron-down" font-scale="1.1" :rotate="tratamiento.collapseOpen ? 180 : 0" @click="toggleCollapse"></b-icon>
      </div>
      <b-collapse class="floating-collapse text-left" :id="'kit'+1" v-model="tratamiento.collapseOpen"
                  accordion="myKit-accordion" role="Kit123panel" style="border: 1px solid #D0D0D0; background-color: white; position: absolute; left: 0; width: 100%; height: 100%;"
                  ref="select-collap"
      >
        <ul id="myUL" style="margin-left: 0px; overflow-y: scroll; padding-left: 15px;" :style="resultadosBusquedaFiltroKits.length > 8 ? 'height: 15em;' : 'height: auto;'">
          <Kits v-for="(itemKit, indexKit) in resultadosBusquedaFiltroKits" :key="indexKit" :itemKit="itemKit" :indexKit="indexKit" @seleccionarKit="seleccionarKit"/>
        </ul>
      </b-collapse>
    </div>
  </div>
</template>

<script>

import Kits from "./Kits.vue";

export default {
  name: "SelectKits" ,
  components: {Kits},
  props: {
    tratamiento: null,
    catalogokits: Array,
  },
  data() {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      resultadosBusquedaFiltroKits: [],
      tratamientosConHijos: [],
      tratamientosOrganizados: null,
      mostrarKits: false,
    };
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  validations: {},
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.organizarTratamientos();
  },
  methods: {
    toggleCollapse(event) {
      event.stopPropagation();
      this.tratamiento.collapseOpen = !this.tratamiento.collapseOpen;
    },

    handleClickOutside(event) {
      const domNode = this.$refs.selectTratamientos;
      if (!domNode || !domNode.contains(event.target)) {
        this.tratamiento.collapseOpen = false;
      }
    },

    seleccionarKit(data){
      if(data != null){
        this.tratamiento.nombreTratamiento = data.nombreKit;
        this.tratamiento.nombreKit = data.nombreKit;
        this.tratamiento.idKit = data.idKit;
        this.tratamiento.listaTratamientos = data.listaTratamientos;
        this.tratamiento.idTratamiento = null;
        this.tratamiento.opcion = this.indexOpcion + 1;
        let precioTotal = 0;
        this.tratamiento.listaTratamientos.forEach(lt => {
          precioTotal = precioTotal + lt.precio;
        });
        this.tratamiento.precio = precioTotal;
        this.tratamiento.isOpen = false;
      }
      this.closeCollapse();
    },

    closeCollapse(){
      this.tratamiento.collapseOpen = false;
    },

    buscarKit() {
      this.tratamiento.collapseOpen = false;
      this.resultadosBusquedaFiltroKits = this.buscar(this.kitsOrganizados)
      this.tratamiento.collapseOpen = true;
    },

    buscar(tratamiento) {
      return tratamiento.filter(p => {
        if (p.nombreKit.toLowerCase().includes(this.tratamiento.nombreKit.toLowerCase().trim())){
          return true;
        }
      })
    },

    organizarTratamientos() {
      this.kitsOrganizados = this.catalogokits;
      this.resultadosBusquedaFiltroKits = this.kitsOrganizados;
    },
  },
}
</script>

<style scoped>
  p {
    color: #6f6f6f;
  }
  .floating-collapse {
    border-radius: 5px;
    z-index: 1000;
  }
  .barras {
    border-width: 1px;
    border-style: solid;
    border-color: #d1d0d0;
    background: #ffffff;
    margin-top: 20px;
    padding-right: 1%;
    padding-left: 1%;
    border-radius: 5px;
    text-align: left;
    align-items: center;
  }

  .scrollable-container-tratamientos {
    overflow-y: auto;
    max-height: 105px;
  }
</style>